import {SpriteConfigName} from "@/entities/game/types";
import {InventoryItemsName} from "@/entities/inventory/types";

export type EffectType = 'none' | 'speed' | 'score' | 'visible';

export interface IActiveEffect {
    id: string;
    type: EffectType;
    value?: number;
    target?: SpriteConfigName;
    remainingHits?: number;
}

export const CONSUMABLE_EFFECTS: Record<string, { type: EffectType, value?: number, target?: SpriteConfigName }> = {
    [InventoryItemsName.AidKit]: { type: "none"},
    [InventoryItemsName.Box100]: { type: "none" },
    [InventoryItemsName.OviFlex100]: { type: 'score', value: 2 },
    [InventoryItemsName.EmptyNet10]: { type: 'visible', target: SpriteConfigName.goalkeeper },
    [InventoryItemsName.EmptyNet25]: { type: 'visible', target: SpriteConfigName.goalkeeper },
};
